module.exports = __webpack_public_path__ + "9f2d8bc5fc663316bf9f6cda104aca6e.svg";